import { DEFAULT_DIALOG_CONFIG, DialogConfig } from '@angular/cdk/dialog';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { aiChatFeature } from '../ai-chat/store/reducers/ai-chat.reducer';
import { META_REDUCERS } from '../core/store/reducers';
import { DEFAULT_MODAL_WIDTH } from './consts/components.consts';
import { CompanyAccountEffects } from './store/effects/company-account.effects';
import { ShowMessageEffect } from './store/effects/show-message.effects';
import { ShowNewSnackbarEffect } from './store/effects/show-new-snackbar.effects';
import { TagsEffect } from './store/effects/tags.effects';
import { reducers } from './store/reducers/shared.reducer';

const SHARED_EFFECTS = [
  CompanyAccountEffects,
  ShowMessageEffect,
  ShowNewSnackbarEffect,
  TagsEffect,
];

@NgModule({
  imports: [
    EffectsModule.forFeature(SHARED_EFFECTS),
    StoreModule.forFeature('shared', reducers, { metaReducers: META_REDUCERS }),
    StoreModule.forFeature(aiChatFeature),
  ],
  providers: [
    {
      provide: DEFAULT_DIALOG_CONFIG,
      useFactory: () => {
        const dialogConfiguration = new DialogConfig();
        dialogConfiguration.backdropClass = ['tw-bg-black/75'];
        dialogConfiguration.disableClose = true;
        dialogConfiguration.width = DEFAULT_MODAL_WIDTH;
        return dialogConfiguration;
      },
    },
  ],
})
export class SharedModule {}
